import React from 'react';

/**
 * Turn plain text URLs into <a> tags; leave other text as-is.
 */
export function linkifyText(text) {
  if (text == null) return null;
  const s = String(text);
  const urlRegex = /(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi;
  const parts = s.split(urlRegex);
  return parts.map((part, i) => {
    if (part.match(/^https?:\/\//i)) {
      return (
        <a key={i} href={part} target="_blank" rel="noopener noreferrer">
          {part}
        </a>
      );
    }
    if (part.match(/^www\./i)) {
      return (
        <a key={i} href={`https://${part}`} target="_blank" rel="noopener noreferrer">
          {part}
        </a>
      );
    }
    return part;
  });
}
